"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationUnitToJSON = exports.DurationUnitFromJSONTyped = exports.DurationUnitFromJSON = exports.DurationUnit = void 0;
/**
 * This signifies what the number in the \'durationAmount\' field is.
 * @export
 * @enum {string}
 */
var DurationUnit;
(function (DurationUnit) {
    DurationUnit["HOUR"] = "HOUR";
    DurationUnit["DAY"] = "DAY";
})(DurationUnit = exports.DurationUnit || (exports.DurationUnit = {}));
function DurationUnitFromJSON(json) {
    return DurationUnitFromJSONTyped(json, false);
}
exports.DurationUnitFromJSON = DurationUnitFromJSON;
function DurationUnitFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DurationUnitFromJSONTyped = DurationUnitFromJSONTyped;
function DurationUnitToJSON(value) {
    return value;
}
exports.DurationUnitToJSON = DurationUnitToJSON;
